import React from 'react'
import cn from 'classnames'
import { AudioLines, File, Film, Image as ImageIcon, Link2, LockKeyhole } from 'lucide-react'
import UserIcon from 'components/users/UserIcon'
import { thinEmbedPresentation } from './postEmbedDisplay'
import styles from './post-embed.module.scss'

const MEDIA_GLYPHS = {
    image: ImageIcon,
    video: Film,
    audio: AudioLines,
    file: File,
    link: Link2,
}

/**
 * The thin render of an answer embed: one row naming who posted and what,
 * instead of the full nested answer.
 *
 * Purely presentational — PostEmbed resolves the answer, owns the click target
 * and the row geometry, and hands the finished answer down. Everything this
 * shows comes from thinEmbedPresentation, which is spec'd on its own.
 *
 * @param {{ answer?: any, fallbackAnswer?: any, label?: string }} props
 */
export default function ThinPostEmbed({ answer, fallbackAnswer, label }) {
    const presentation = thinEmbedPresentation(answer, fallbackAnswer)

    if (presentation.isPrivate) {
        return (
            <div className={cn(styles.thinEmbed, styles.thinEmbedPrivate)}>
                <LockKeyhole className={styles.thinEmbedGlyph} aria-hidden="true" />
                <span className={styles.thinEmbedSnippet}>Private</span>
            </div>
        )
    }

    const MediaGlyph = presentation.mediaKind ? MEDIA_GLYPHS[presentation.mediaKind] : null

    return (
        <div className={styles.thinEmbed}>
            {label && <span className={styles.thinEmbedLabel}>{label}</span>}
            <UserIcon
                user={presentation.author}
                size="small"
                virtualUserIcon={presentation.authorIconUrl}
                contextStyles={styles.thinEmbedAvatar}
            />
            {presentation.authorName && (
                <span className={styles.thinEmbedAuthor}>{presentation.authorName}</span>
            )}
            {MediaGlyph && <MediaGlyph className={styles.thinEmbedGlyph} aria-hidden="true" />}
            <span className={styles.thinEmbedSnippet}>
                {presentation.isRecursiveQuote && !presentation.snippet
                    ? '…'
                    : presentation.snippet}
            </span>
        </div>
    )
}
